import React from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "@ecommerce/store";
import { useCategories } from "./hooks/useCategories";
import { useCategoriesNavigation } from "./hooks/useNavigation";
import { useNavbarCategoriesDrawer } from "./hooks/useNavbarCategoriesDrawer";
import ShoppingCartDrawer from "../ShoppingCart/ShoppingCartDrawer";
import { CategoriesDrawer } from "./Navbar/CategoriesMenu/CategoriesDrawer";
import { GlassNav, PromoStrip } from "../liquid/LiquidPrimitives";

const getActiveNavKey = (pathname: string) => {
  if (pathname === "/") return "home";
  if (pathname.includes("acero-dorado")) return "gold";
  if (pathname.includes("acero-quirurgico-blanco")) return "white";
  if (pathname.includes("hilo-y-acero")) return "cord";
  if (pathname.includes("pulseras-charms") || pathname.includes("charms")) return "charms";
  if (pathname.includes("productos") || pathname.includes("search")) return "new";
  return "home";
};

const Header: React.FC = () => {
  const location = useLocation();
  const { cartCount, cartItems, isCartOpen, toggleCart, closeCart } = useCart();
  const { rootCategories, loading, error, getSubcategories } = useCategories();

  const {
    drawerOpen,
    productosOpen,
    expandedCategories,
    toggleDrawer,
    toggleProductos,
    toggleCategory,
    closeDrawer,
  } = useNavbarCategoriesDrawer();

  const { handleNavigation, handleCategoryClick, handleViewAllInCategory } =
    useCategoriesNavigation(closeDrawer);

  return (
    <>
      <PromoStrip />
      <GlassNav
        active={getActiveNavKey(location.pathname)}
        cartCount={cartCount}
        onMenuClick={toggleDrawer}
        onCartClick={toggleCart}
      />

      <CategoriesDrawer
        isOpen={drawerOpen}
        loading={loading}
        error={error}
        rootCategories={rootCategories}
        productosOpen={productosOpen}
        expandedCategories={expandedCategories}
        onClose={closeDrawer}
        onNavigate={handleNavigation}
        onToggleProductos={toggleProductos}
        onToggleCategory={toggleCategory}
        onCategoryClick={handleCategoryClick}
        onViewAllClick={handleViewAllInCategory}
        getSubcategories={getSubcategories}
      />

      <ShoppingCartDrawer
        cartItems={cartItems}
        isOpen={isCartOpen}
        onClose={closeCart}
        cartCount={cartCount}
      />
    </>
  );
};

export default Header;
